const scrollTop = {
    init() {

        const btnToTopAnchor = document.getElementById("btnToTopAnchor");
        const btnToTop = document.getElementById('btnToTop');

        if (btnToTopAnchor) {
            btnToTopAnchor.addEventListener('click', function(e) {
                e.preventDefault();
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        }



        if (btnToTop) {
            window.onscroll = function()
            {
                if(window.pageYOffset >= 1000){
                    btnToTop.classList.add("show");
                }
                else {
                    btnToTop.classList.remove("show");
                }
            
            };
        }
    },
};

export default scrollTop;